import avatar from '../../images/blueRaisedAvatar.png';
import styles from '../Avatar/Avatar.module.scss';

function Avatar() {
  return <img className={styles.avatar} src={avatar} alt={'avatar'} width={'100%'} />;
}

export default Avatar;
